module.exports = __webpack_public_path__ + "media/images/new_home/white-edit-icon-b31e1fee3b6c0fa5e7f5b45694bcd419.png";